import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

export const getCartListApi = () => {
  return axios.get(getBaseURL() + ENDPOINTS.CART_LIST, {
    headers: getHeaders(),
  });
};
